import clsx from 'clsx';

/**
 * StokSekme — Kullanım / Stok arasında geçiş yapan sekme toggle
 * 
 * @param {'kullanim'|'stok'} activeTab
 * @param {Function} onTabChange
 */
export default function StokSekme({ activeTab = 'kullanim', onTabChange }) {
    const tabs = [
        { key: 'kullanim', label: 'Kullanım' },
        { key: 'stok', label: 'Stok' },
    ];

    return (
        <div className="flex gap-1 p-1 bg-bg-tertiary rounded-lg w-fit">
            {tabs.map(tab => (
                <button
                    key={tab.key}
                    onClick={() => onTabChange(tab.key)}
                    className={clsx(
                        'px-4 py-2 text-sm font-medium rounded-md transition-all',
                        activeTab === tab.key
                            ? 'bg-bg-secondary text-text-primary shadow-sm'
                            : 'text-text-muted hover:text-text-secondary'
                    )}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
}
